// Pročitaj hostname iz browsera
const hostname = window?.location?.hostname || "";
// Ako domen počinje sa "clivet.", važi Clivet konfiguracija
const isClivet = hostname.startsWith("clivet.");
const isProlux = hostname.startsWith("prolux.");

// Brand detection utility
export const getCurrentBrand = () => {
  const hostname = window?.location?.hostname?.toLowerCase() || "";

  // Handle localhost subdomains for development
  if (hostname === "clivet.localhost" || hostname.startsWith("clivet.")) {
    return "clivet";
  } else if (
    hostname === "prolux.localhost" ||
    hostname.startsWith("prolux.")
  ) {
    return "prolux";
  } else if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "termovent"; // localhost:3000 = Termovent (default)
  }
  return "termovent"; // Default brand for production
};

/** Termovent (default) vrednosti za lokaciju */
const termoventLocation = {
  address: "Kneza Milosa 88a",
  city: "Belgrade",
  country: "Serbia",
  countryShortCode: "RS",
  markerPosition: { lat: 44.80033, lng: 20.45333 },
  elevation: "117",
};

/** Clivet vrednosti za lokaciju */
const clivetLocation = {
  address: "Via Camp Lonc, 25 – Z.I. Villapaiera, Feltre",
  city: "Feltre",
  country: "Italy",
  countryShortCode: "IT",
  markerPosition: { lat: 45.33123, lng: 9.44745 },
  elevation: "234",
};

// Change THIS only: "dev" | "staging" | "prod"
const ENV = "prod";

const COMMON = {
  appName: "Climate-Prime",
  appVersion: "v1.0.5.2",
  interactiveUrl: "https://termovent.com",
  jwt_key_name: "jwt", // localStorage key,
  captcha_sitekey: "6Ldl3bEcAAAAAKD5m1v7sb3n_1jhjUJot-QLELgl",
  captcha_secret: "6Ldl3bEcAAAAANpUWEZYs_cz5H8NzFp391jYAMvv",
  google_map_api_key: "AIzaSyAvuT5vx21LcbzOu-1FFt2kCR4RjdGiluU",
  airvisual_api_key: "f6ee8e80-1d2a-4cb5-8e7e-6cd8cca9b903",
  defaultLocation: isClivet ? clivetLocation : termoventLocation,
  termoventHQ: isClivet
    ? clivetLocation.markerPosition
    : termoventLocation.markerPosition,
};

const BY_ENV = {
  dev: {
    base_url: "https://localhost:44358/api",
    calculationUrl: "https://localhost:44308/api", //"https://calculation.climate-prime.com/api",
  },
  staging: {
    base_url: "https://climate-primetest.azurewebsites.net/api",
    calculationUrl: "https://test-calculation.climate-prime.com/api",
  },
  prod: {
    base_url: "https://climate-prime.com/api",
    calculationUrl: "https://calculation.climate-prime.com/api",
  },
};

const config = {
  ENV,
  ...COMMON,
  ...BY_ENV[ENV],
};

export default config;
